import React from "react";
import whatwedoimg2 from "../assets/images/what-we-do-img-2.jpg";
import whatwedoimg from "../assets/images/what-we-do-img-1.jpg";

function Onboardingplatform() {
  return (
    <>
      <div className="page-header">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              {/* Page Header Box Start */}
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">
                  Onboarding Platform
                </h1>
                <nav className="wow fadeInUp">
                  <ol className="breadcrumb"></ol>
                </nav>
              </div>
              {/* Page Header Box End */}
            </div>
          </div>
        </div>
      </div>

      <div className="what-we-do">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              {/* What We Do Content Start */}
              <div className="what-we-do-content">
                {/* Section Title Start */}
                <div className="section-title">
                  {/* <h3 className="wow fadeInUp">what we do</h3> */}
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Onboarding Platform
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    An onboarding platform is an essential tool for businesses
                    looking to quickly and efficiently onboard new customers
                    while ensuring compliance with regulatory requirements. Our
                    solution allows business to digitally onboard users by
                    conducting instant background verification with real-time
                    KYC checks.
                  </p>
                </div>

                {/* What We Do Button End */}
              </div>
              {/* What We Do Content End */}
            </div>
            <div className="col-lg-6">
              {/* What We Do Images Start */}
              <div className="what-we-do-images">
                {/* What We Do Image 1 Start */}
                <div className="what-do-we-img-1">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg} alt="whatwedoimg" />
                  </figure>
                </div>
                {/* What We Do Image 1 End */}
                {/* What We Do Image 2 Start */}
                <div className="what-do-we-img-2">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg2} alt="whatwedoimg2" />
                  </figure>
                </div>
                {/* What We Do Image 2 End */}
                {/* Experience Counter Box Start */}
                <div className="experience-counter-box">
                  <div className="experience-counter-no">
                    <h2>
                      <span className="counter">5</span>+
                    </h2>
                  </div>
                  <div className="experience-counter-content">
                    <p>Years of experience in finance</p>
                  </div>
                </div>
                {/* Experience Counter Box Start End */}
              </div>
              {/* What We Do Images End */}
            </div>
          </div>
        </div>
      </div>
      <div className="what-we-do">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              {/* What We Do Images Start */}
              <div className="what-we-do-images">
                {/* What We Do Image 1 Start */}
                <div className="what-do-we-img-1">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg} alt="whatwedoimg" />
                  </figure>
                </div>
                {/* What We Do Image 1 End */}
                {/* What We Do Image 2 Start */}
                <div className="what-do-we-img-2">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg2} alt="whatwedoimg2" />
                  </figure>
                </div>
                {/* What We Do Image 2 End */}
                {/* Experience Counter Box Start */}
                <div className="experience-counter-box">
                  <div className="experience-counter-no">
                    <h2>
                      <span className="counter">5</span>+
                    </h2>
                  </div>
                  <div className="experience-counter-content">
                    <p>Years of experience in finance</p>
                  </div>
                </div>
                {/* Experience Counter Box Start End */}
              </div>
              {/* What We Do Images End */}
            </div>
            <div className="col-lg-6">
              {/* What We Do Content Start */}
              <div className="what-we-do-content">
                {/* Section Title Start */}
                <div className="section-title">
                  {/* <h3 className="wow fadeInUp">what we do</h3> */}
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Our Offerings
                  </h2>
                  {/* <p className="wow fadeInUp" data-wow-delay="0.2s">
                                        Customize digital payment experience with Neo Banking & Payout Platform          </p> */}
                </div>
                <div
                  className="what-we-do-list wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <ul>
                    <li>Aadhaar Verification</li>
                    <li>PAN composite Verification</li>
                    <li>Voter ID Verification</li>
                    <li>Passport Verification</li>
                    <li>Driving License Verification</li>
                    <li>Bank Verification (Penny drop)</li>
                    <li>UPI Validation</li>
                    <li>GST Verification</li>
                    <li>MCA CIN search Verification</li>
                    <li>Face Match</li>
                    <li>SMS API</li>
                  </ul>
                </div>
                {/* What We Do List End */}
                {/* What We Do Button Start */}
                <div
                  className="what-we-do-btn wow fadeInUp"
                  data-wow-delay="0.6s"
                >
                  <a href="contact.html" className="btn-default">
                    contact now
                  </a>
                </div>
                {/* What We Do Button End */}
              </div>
              {/* What We Do Content End */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Onboardingplatform;
